const { h } = require('@vue/composition-api');import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _typeof from "@babel/runtime/helpers/esm/typeof";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.filter.js";
import Vue from 'vue';
import { mergeData } from 'vue-functional-data-merge';

function generateName(name) {
  return name.toLowerCase().replace(/\.svg$/, '').replace(/[^a-z0-9-]/g, '-');
}
/**
 * Find sprite file name after nuxt build
 * @param {string} sprite Name of a sprite
 */


function getSpritePath(sprite) {
  var module = require('~/assets/sprite/gen/' + sprite + '.svg');

  if (typeof module === 'string') {
    return module;
  } // nuxt-edge v3.0.0-26398097.20b0379b returns object instead of string


  if (_typeof(module) === 'object' && typeof module.default === 'string') {
    return module.default;
  }

  return '';
}

function getIcon(info) {
  var icon = info.icon,
      sprite = info.sprite;
  return getSpritePath(sprite) + "#i-".concat(generateName(icon));
}

function getInfo(name) {
  var _name$split = name.split('/'),
      _name$split2 = _slicedToArray(_name$split, 2),
      sprite = _name$split2[0],
      icon = _name$split2[1];

  if (!icon) {
    icon = sprite;
    sprite = 'icons';
  }

  return {
    icon: icon,
    sprite: sprite
  };
} // @vue/component


var SvgIcon = {
  name: 'SvgIcon',
  functional: true,
  props: {
    name: {
      type: String,
      required: true
    },
    title: {
      type: String,
      default: null
    },
    desc: {
      type: String,
      default: null
    },
    viewBox: {
      type: String,
      default: null,
      validator: function validator(value) {
        return value.split(' ').every(function (v) {
          return !isNaN(parseInt(v));
        });
      }
    }
  },
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data;
    var info = getInfo(props.name);
    var icon = getIcon(info);
    var use = h('use', {
      attrs: {
        // Since SVG 2, the xlink:href attribute is deprecated in favor of simply href.
        href: icon,
        // xlink:href can still be required in practice for cross-browser compatibility.
        'xlink:href': icon
      }
    });
    var title = props.title ? h('title', props.title) : null;
    var desc = props.desc ? h('desc', props.desc) : null;
    var sprite = info.sprite;
    var componentData = {
      class: 'icon sprite-' + sprite,
      attrs: {
        xmlns: 'http://www.w3.org/2000/svg',
        viewBox: props.viewBox
      }
    };
    return h('svg', mergeData(data, componentData), [title, desc, use].filter(Boolean));
  }
};
Vue.component(SvgIcon.name, SvgIcon);